const request = require('request');
const config = require('./config');

const get = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/permissao',
      method: 'GET',
      qs: filters
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body:body});
    });
  });
};

const getByID = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/permissao/'+filters.permissao_id_md5,
      method: 'GET',
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body:body});
    });
  });
};

const post = (token,data) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/permissao',
      method: 'POST',
      body: JSON.stringify(data)
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve(body);
    });
  });
};

const put = (token,data,id) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/permissao/'+id,
      method: 'PUT',
      body: JSON.stringify(data)
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve(body);
    });
  });
};

const remove = (token,id) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/permissao/'+id,
      method: 'DELETE',
    }, (err, res, body) => {
      if (err) {
        console.error(err);
        return reject(err);
      }
      resolve({err: err, res: res, body:body});
    });
  });
};

module.exports = {
  get:get,
  getByID:getByID,
  post:post,
  put:put,
  remove:remove
};